export default __webpack_public_path__ + "static/media/reparatie_motor_binnenboord.8583a7d3.svg";